/*
 * vrtPSSetting.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSSetting: RouteRecordRaw = {
  path: '/powersteer/setting',
  name: 'vrtPSSetting',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // ADMIN
    // TRAINER
    // TRAINEE
    {
      path: 'trainee/frametrainee/paradestate/lu/option/list',
      name: 'vrtPSSettingFrameTraineeParadeStateLUOptionList',
      component: () => import('./vpgPSSettingFrameTraineeParadeStateLUOptionList.vue'),
    },
    {
      path: 'trainee/frametrainee/paradestate/lu/option/operate',
      name: 'vrtPSSettingFrameTraineeParadeStateLUOptionOperate',
      component: () => import('./vpgPSSettingFrameTraineeParadeStateLUOptionOperate.vue'),
    },
    // eLAUNCH
    {
      path: 'elaunch/list',
      name: 'vrtPSSettingeLaunchList',
      component: () => import('./vpgPSSettingeLaunchList.vue'),
    },
    {
      path: 'elaunch/create',
      name: 'vrtPSSettingeLaunchCreate',
      component: () => import('./vpgPSSettingeLaunchCreate.vue'),
    },
    {
      path: 'elaunch/update',
      name: 'vrtPSSettingeLaunchOperate',
      component: () => import('./vpgPSSettingeLaunchOperate.vue'),
    },
    // AC ASSESSMENT
    {
      path: 'ac/accriterialist',
      name: 'vrtPSSettingACCriteriaList',
      component: () => import('./vpgPSSettingACCriteriaList.vue'),
    },
    {
      path: 'ac/accriteriaoperate',
      name: 'vrtPSSettingACCriteriaOperate',
      component: () => import('./vpgPSSettingACCriteriaOperate.vue'),
    },
    // FnA ASSESSMENT
    {
      path: 'fna/fnacriterialist',
      name: 'vrtPSSettingFnACriteriaList',
      component: () => import('./vpgPSSettingFnACriteriaList.vue'),
    },
    {
      path: 'fna/fnacriteriaoperate',
      name: 'vrtPSSettingFnACriteriaOperate',
      component: () => import('./vpgPSSettingFnACriteriaOperate.vue'),
    },
    // FTA ASSESSMENT
    {
      path: 'fta/ftacriteriaitemlist',
      name: 'vrtPSSettingFTACriteriaItemList',
      component: () => import('./vpgPSSettingFTACriteriaList.vue'),
    },
    {
      path: 'fta/ftacriteriaitemoperate',
      name: 'vrtPSSettingFTACriteriaItemOperate',
      component: () => import('./vpgPSSettingFTACriteriaOperate.vue'),
    },
    // TLS TYPE
    {
      path: 'tls/typelist',
      name: 'vrtPSSettingTLSTypeList',
      component: () => import('./vpgPSSettingTLSTypeList.vue'),
    },
    {
      path: 'tls/typeoperate',
      name: 'vrtPSSettingTLSTypeOperate',
      component: () => import('./vpgPSSettingTLSTypeOperate.vue'),
    },
    // TLS TESTER
    {
      path: 'tls/testerlist',
      name: 'vrtPSSettingTLSTesterList',
      component: () => import('./vpgPSSettingTLSTesterList.vue'),
    },
    {
      path: 'tls/testeroperate',
      name: 'vrtPSSettingTLSTesterOperate',
      component: () => import('./vpgPSSettingTLSTesterOperate.vue'),
    },
    // TLS FAULT
    {
      path: 'tls/faultlist',
      name: 'vrtPSSettingTLSFaultList',
      component: () => import('./vpgPSSettingTLSFaultList.vue'),
    },
    {
      path: 'tls/faultoperate',
      name: 'vrtPSSettingTLSFaultOperate',
      component: () => import('./vpgPSSettingTLSFaultOperate.vue'),
    },
    {
      path: 'tls/ehelp/notification/list',
      name: 'vrtPSeHELPNotifyList',
      component: () => import('./vpgPSeHELPNotificationList.vue'),
    },
  ],
};

export default vrtPSSetting;
